import {
    GET_UNITS_DETAIL_REQUEST,
    GET_UNITS_DETAIL_SUCCESS,
    GET_UNITS_DETAIL_FAILURE
} from '../actions/UnitsDetailActions';


const initialState = {};

const UnitsDetailReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_UNITS_DETAIL_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case GET_UNITS_DETAIL_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: {...state.data, [action.id]: action.payload}});
        case GET_UNITS_DETAIL_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default UnitsDetailReducer;